import type { ReferentialEnum } from "@pharmupp/p3-front-commons"

export type UserTitlesNames = keyof typeof userTitleEnum
export const userTitleEnum = {
  MS: { label: "Madame" },
  MR: { label: "Monsieur" },
} as const satisfies ReferentialEnum
